<script>
import { apis } from '@/utils/api.js';
import { userStore } from '@/stores/user.js';
import { configStore } from '@/stores/config.js';
import sensors from 'sa-sdk-javascript'
import { initializeApp } from "firebase/app";
import { getAnalytics,getGoogleAnalyticsClientId } from "firebase/analytics";

const osName = uni.getSystemInfoSync().osName
const uniPlatform = uni.getSystemInfoSync().uniPlatform
const parseCookies = (cookieString) => {
	const cookies = {};
	if (cookieString === '') return cookies;
	cookieString.split('; ') .forEach(kv => {
	    const [k, v] = kv.split('=');
	    cookies[k] = v;          
	});
	return cookies;  	
};
export default {
	onLaunch: function() {
		
		// 语言环境设置为西班牙
		uni.setLocale('es');
		// 初始化用户数据
		console.log('App Launch');
		uni.$api = apis;
		// #ifdef APP-PLUS
		const store = userStore();
		store.initUserData("initUserStepData");
		const cstore = configStore();
		cstore.initConfigData();
		// #endif
		const firebaseConfig = {
		  apiKey: "AIzaSyCFVI9vQWgjMUUhgUrM8dqvnULYWBglNhE",
		  authDomain: "expressc-9ef81.firebaseapp.com",
		  projectId: "expressc-9ef81",
		  storageBucket: "expressc-9ef81.firebasestorage.app",
		  messagingSenderId: "22648074003",
		  appId: "1:22648074003:web:977b00f1f6455e7ccbb4e6",
		  measurementId: "G-LWXJ28K05L"
		};
		
		const app = initializeApp(firebaseConfig);
		const analytics = getAnalytics(app);
		getGoogleAnalyticsClientId(analytics).then(ret => {
			uni.setStorageSync('analytics', ret);
		})
		const cookiesObj = parseCookies(document.cookie);
		if(cookiesObj._fbp){
			uni.setStorageSync('fbp', cookiesObj._fbp);
		}
		if(cookiesObj._fbc){
			uni.setStorageSync('fbc', cookiesObj._fbc);
		}
		if(cookiesObj._ttp){
			uni.setStorageSync('ttp', cookiesObj._ttp);
		}
		
		
		sensors.init({
		  // server_url: 'https://sen.fcredit.kz/sa?project=Kazakhstan_Test',//测试
		  server_url: 'https://sen.fcredit.kz/sa?project=Kazakhstan', //正式
		  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
		  use_client_time: true,
		  send_type: 'beacon',
		  show_log: false,
		  heatmap: {
		    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
		    clickmap: 'not_collect',
		    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
		    scroll_notice_map: 'not_collect'
		  }
		});
		const presetProperties = sensors.getPresetProperties();
		uni.setStorageSync('distinctid',presetProperties._distinct_id)
		
		apis.home.channeladd().then(res => {})
	},
	onShow: function(option) {
		if(uniPlatform != 'web'){
			var args = plus.runtime.arguments
			if(args){
				const queryString = args.split('?')[1];
				const params = {};
				if (queryString) {
				    const pairs = queryString.split('&');
				    pairs.forEach(pair => {
				        const [key, value] = pair.split('=');
				        params[decodeURIComponent(key)] = decodeURIComponent(value);
				    });
				}
				uni.setStorageSync('source',params)
				uni.reLaunch({
					url: '/pages/home/index'
				})
			}
		}else{
			// let options = uni.getLaunchOptionsSync();
			// let query = options.query;
			// const sourceid = query.sourceid || ''
			// if(sourceid){
			// 	uni.setStorageSync('sourceid',sourceid)
			// }	
			const urlParams = new URLSearchParams(window.location.search);
			const channel = urlParams.get('channel') || '';
			const ttclid = urlParams.get('ttclid') || '';
			const sourceid = urlParams.get('sourceid') || '';
			const click_id = urlParams.get('click_id') || '';
			const utm_term = urlParams.get('utm_term') || '';
			if(channel){
				uni.setStorageSync('channel',channel)
			}
			if(ttclid){
				uni.setStorageSync('ttclid',ttclid)
			}
			if(sourceid){
				uni.setStorageSync('sourceid',sourceid)
			}
			if(click_id){
				uni.setStorageSync('click_id',click_id)
			}
			if(utm_term){
				uni.setStorageSync('utm_term',utm_term)
			}
			const source = urlParams.get('source') || '';
			if(source){
				uni.reLaunch({
					url: '/pages/home/index'
				})
			}	
		}
		console.log('App Show');
	},
	onLoad:function (e){
		console.log(e);
	},
	onHide: function() {
		console.log('App Hide');
	}
};
</script>
<style>
/*每个页面公共css */
.full-screen {
	/* #ifdef APP-PLUS */
	position: fixed;
	/* #endif */
	/* #ifndef APP-PLUS */
	position: fixed !important;
	/* #endif */
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}
.items-center {
	display: flex;
	/* #ifdef APP-PLUS */
	align-items: center;
	/* #endif */
	/* #ifndef APP-PLUS */
	align-items: center !important;
	/* #endif */
}
.justify-center {
	display: flex;
	/* #ifdef APP-PLUS */
	justify-content: center;
	/* #endif */
	/* #ifndef APP-PLUS */
	justify-content: center !important;
	/* #endif */
}
.justify-between {
	display: flex;
	/* #ifdef APP-PLUS */
	justify-content: space-between;
	/* #endif */
	/* #ifndef APP-PLUS */
	justify-content: space-between !important;
	/* #endif */
}
.items-end {
	display: flex;
	/* #ifdef APP-PLUS */
	align-items: flex-end;
	/* #endif */
	/* #ifndef APP-PLUS */
	align-items: flex-end !important;
	/* #endif */
}
.items-start {
	display: flex;
	/* #ifdef APP-PLUS */
	align-items: flex-start;
	/* #endif */
	/* #ifndef APP-PLUS */
	align-items: flex-start !important;
	/* #endif */
}
.flex-col {
	display: flex;
	/* #ifdef APP-PLUS */
	flex-direction: column;
	/* #endif */
	/* #ifndef APP-PLUS */
	flex-direction: column !important;
	/* #endif */
}
.flex-row {
	display: flex;
	/* #ifdef APP-PLUS */
	flex-direction: row;
	/* #endif */
	/* #ifndef APP-PLUS */
	flex-direction: row !important;
	/* #endif */
}
/* #ifdef H5 */
body {
	background-color: #fff;
}
/* #endif */
.swiper .uni-swiper-wrapper .uni-swiper-dots-horizontal .uni-swiper-dot-active {
	width: 32rpx !important;
	height: 16rpx !important;
	border-radius: 8rpx !important;	
}
</style>
<style lang="scss">
</style>